export class GiftCardPosterModel {
  "_id":string =  "5fc5c70b9ad95b361596ded3"
  "posterImageUrl":string =  "https://brainlitz-dev.s3.amazonaws.com/temp/posters/gift-card-1.png"
  "description":string =  "Gift card description"
}
